
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 6.751V2.25a1.5 1.5 0 011.5-1.5h4.5m16.5 6.001V2.25a1.5 1.5 0 00-1.5-1.5h-4.5M.75 17.25v4.5a1.5 1.5 0 001.5 1.5h4.5m16.5-6v4.5a1.5 1.5 0 01-1.5 1.5h-4.5M7.875 8.625a4.125 4.125 0 108.25 0 4.125 4.125 0 10-8.25 0zM18.337 18.75a6.712 6.712 0 00-12.674 0","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    